let subscribers={};function subscribe(eventName,callback){return subscribers[eventName]===void 0&&(subscribers[eventName]=[]),subscribers[eventName]=[...subscribers[eventName],callback],function(){subscribers[eventName]=subscribers[eventName].filter(cb=>cb!==callback)}}function publish(eventName,data){if(subscribers[eventName]){const promises=subscribers[eventName].map(callback=>callback(data));return Promise.all(promises)}else return Promise.resolve()}

/* LMB correctif position selecteur couleur */
(function(){
  var D='(min-width: 750px)';
  function info(){return document.querySelector('.product__info-container');}
  function qty(){var i=info();if(!i)return null;var q=i.querySelector('.product-form__quantity');if(!q)return null;while(q&&q.parentElement!==i)q=q.parentElement;return q;}
  function pk(){var i=info();if(!i)return[];var o=[];var v=i.querySelector('variant-selects');if(v)o.push(v);var g=document.querySelector('gg-swatch');if(g)o.push(g);return o;}
  function place(){try{var i=info();if(!i)return;var ps=pk();if(!ps.length)return;var ref;if(window.matchMedia(D).matches){ref=qty();if(!ref)return;}else{ref=i.firstElementChild;while(ref&&ps.indexOf(ref)!==-1)ref=ref.nextElementSibling;}if(!ref)return;var ok=ps.every(function(e){return e.parentElement===i;})&&ps[ps.length-1].nextElementSibling===ref;if(ok){for(var k=1;k<ps.length;k++){if(ps[k-1].nextElementSibling!==ps[k]){ok=false;break;}}}if(ok)return;ps.forEach(function(e){i.insertBefore(e,ref);});}catch(e){}}
  ['DOMContentLoaded','load'].forEach(function(e){window.addEventListener(e,place);});
  ['variant:change','variant:changed','on:variant:change'].forEach(function(e){document.addEventListener(e,function(){setTimeout(place,0);},true);});
  document.addEventListener('change',function(){setTimeout(place,0);},true);
  try{window.matchMedia(D).addEventListener('change',place);}catch(e){}
  var n=0,iv=setInterval(function(){place();if(++n>25)clearInterval(iv);},300);
})();

/* LMB - active viewport-fit=cover : permet a la sticky bottom:0 d'atteindre le vrai bas
   de l'ecran sur Safari/Chrome iOS (sinon un espace apparait au-dessus de la barre du navigateur)
   et active env(safe-area-inset-bottom). */
(function () {
  try {
    var m = document.querySelector('meta[name=viewport]');
    if (m && m.getAttribute('content').indexOf('viewport-fit') === -1) {
      m.setAttribute('content', m.getAttribute('content') + ', viewport-fit=cover');
    }
  } catch (e) {}
})();

/* LMB - barre d'annonce collante au scroll (la rotation du carrousel reste active).
   La section annonce devient sticky en haut, et le header sticky du theme est decale
   de la hauteur reelle de la barre pour s'empiler proprement dessous. */
(function () {
  try {
    var style = document.createElement('style');
    style.textContent =
      '.announcement-bar-section{position:sticky;top:0;z-index:6;}'
      + '.shopify-section-header-sticky{top:var(--mdb-ann-h,0px)!important;}'
      + '@media(min-width:750px){.announcement-bar__message{font-weight:400!important;}}'; // pas de gras sur ordinateur
    (document.head || document.documentElement).appendChild(style);
  } catch (e) {}
  function annEl() { return document.querySelector('.announcement-bar-section'); }
  function measure() {
    var a = annEl();
    if (a) document.documentElement.style.setProperty('--mdb-ann-h', (a.offsetHeight || 0) + 'px');
  }
  function init() {
    measure();
    var a = annEl();
    if (a && 'ResizeObserver' in window) { try { new ResizeObserver(measure).observe(a); } catch (e) {} }
  }
  ['DOMContentLoaded', 'load'].forEach(function (e) { window.addEventListener(e, init); });
  window.addEventListener('resize', measure);
  var n = 0, iv = setInterval(function () { measure(); if (++n > 20) clearInterval(iv); }, 500);

  function rotateMobile() {
    try {
      if (!window.matchMedia('(max-width:749px)').matches) return;
      var slider = document.querySelector('.announcement-bar .slider');
      if (!slider) return;
      var slides = slider.querySelectorAll('.slideshow__slide');
      if (slides.length < 2) return;
      var idx = 0, min = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - slider.scrollLeft);
        if (d < min) { min = d; idx = i; }
      }
      var next = (idx + 1) % slides.length;
      slider.scrollTo({ left: slides[next].offsetLeft, behavior: 'smooth' });
    } catch (e) {}
  }
  setInterval(rotateMobile, 4000);
})();

/* LMB loader sticky add to cart */
(function(){
  try{
    if(!document.querySelector('.product__info-container')) return;
    if(document.querySelector('script[data-mdb-sticky]')) return;
    var s=document.querySelector('script[src*="/assets/pubsub.js"]');
    if(!s) return;
    var u=s.src.replace(/pubsub\.js/,'sticky-add-to-cart.js');
    var sc=document.createElement('script');
    sc.src=u; sc.defer=true; sc.setAttribute('data-mdb-sticky','1');
    document.head.appendChild(sc);
  }catch(e){}
})();
